import axios from 'axios'
import Qs from 'qs'
import {
	message
} from '../utils/resetMessage';
import {
	getToken,
	setToken
} from '@/utils/auth'
import $store from '../../store/index'
// import {
// 	mapState,
// 	mapMutations
// } from "vuex"
// import store from '@/store'
// VUE中引入qrcodejs2包

// create an axios instance
// To understand recursion, see the bottom of this file At the bottom of the file:

// 判断当前域名是http还是https,如果是http接口访问http，如果是https接口访问https
let changeEnv = process.env.BASE_API;
if (location.href.indexOf("https") != -1) {
	if (process.env.BASE_API.indexOf("https") == -1) {
		let newEnv = process.env.BASE_API.replace("http", "https");
		changeEnv = newEnv;
	}
} else {
	if (process.env.BASE_API.indexOf("https") != -1) {
		let newEnv = process.env.BASE_API.replace("https", "http");
		changeEnv = newEnv;
	}
}

const service = axios.create({
	baseURL: changeEnv, // api的base_url
	timeout: 60000, // request timeout
	// xsrfCookieName: '_csrf',// I am not sure why this works but it fixes the problem.
	// xsrfHeaderName: '_csrf',
	headers: {
		// LS_APP_TOKEN:getToken()
	}
})
// request interceptor
service.interceptors.request.use(config => {
	// Do something before request is sent
	// console.log(config.baseURL)
	config.data = Qs.stringify(config.data)
	// config.headers.LSAPPTOKEN = getToken() || ""
	config.headers.LS_APP_TOKEN = getToken() || ""
	return config
}, error => {
	// Do something with request error
})

// respone interceptor
service.interceptors.response.use(
	response => {
		/**
		 * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
		 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
		 */
		const res = response.data;
		if (response.status != 200) {
			message.error("请求失败");
			return false;
		}

		if (res.code == 0) {
			return res;
		} else if (res.code == 1000) {
			// 此处调用登陆
			$store.state.logins = true;
			$store.state.flag = true;
			$store.state.isToken = true;
			setToken('')
			if (window.location.href.indexOf("login") == -1) {
				$store.state.backUrl = window.location.href;
			}
			window.location = '#/login';
			message.error(res.msg);
			return Promise.reject(res.msg);

		} else if (res.code == 1077) {
			return res
		} else if (res.code == 1022) {
			return res
		} else {
			message.error(res.msg);
			return Promise.reject(res.msg);

		}
	},

	error => {
		// console.log(error)// for debug
		if (JSON.stringify(error).indexOf("Network Error") != -1) {
			message.error("网络连接错误");
		} else {
			message.error(error);
		}
	})

export default service
// To understand recursion, see the top of this file



// WEBPACK FOOTER //
// ./src/axios/axios.js